import Vue from 'vue';
export default Vue.extend({
    props: {
        title: String,
        subtitle: String,
        content: String,
        logo: {
            type: Object,
            default: null
        },
        playbutton: {
            type: Boolean,
            default: false
        }
    }
});
